// 活动信息
const EventCode = 240714;

export const EventInfo = {
    // 活动基本信息
    eventCode: EventCode,
    bannerLinks: [{
        name: "排行榜",
        link: "https://ix.icode.org.cn/rankBoard?eventCode=" + EventCode,
        show: true,
    }, {
        name: "蜀少年云平台",
        link: "https://scssn.cn",
        show: true,
    }],
    eventGameList: [{
        name: "图形化儿童A组", // 组别名称
        id: EventCode * 100 + 1, // 比赛ID
        mode: 0, // 比赛模式：0-积木，1-Python
        minGrade: 0, // 组别最低年级（包含，0-13）
        maxGrade: 4 // 组别最高年级（包含，0-13）
    }, {
        name: "图形化儿童B组",
        id: EventCode * 100 + 2,
        mode: 0,
        minGrade: 2,
        maxGrade: 7
    }, {
        name: "图形化儿童少年组",
        id: EventCode * 100 + 3,
        mode: 0,
        minGrade: 6,
        maxGrade: 13
    }, {
        name: "Python儿童B组",
        id: EventCode * 100 + 11,
        mode: 1,
        minGrade: 0,
        maxGrade: 7
    }, {
        name: "Python少年组",
        id: EventCode * 100 + 12,
        mode: 1,
        minGrade: 6,
        maxGrade: 13
    }],

    orgList: {
        "主办单位": [""],
        "承办单位": [],
        // "主办单位：共青团四川省委、四川省精神文明建设办公室",
        // "　　　　　四川省教育厅、四川省科学技术厅",
        // "　　　　　四川省文化和旅游厅、四川省广播电视局",
        // "　　　　　四川省关心下一代工作委员会、四川省少先队工作委员会",
        // "承办单位：四川省青少年社会教育服务中心、四川省文化馆",
        // "协办单位：各市（州）团委、少工委",
        // "　　　　　成都成电创客科技有限公司、四川天府润禾科技有限公司",
        // "技术支持：ICode中国区组委会"
    }
}


// WEBPACK FOOTER //
// ./src/components/contest/SCSSN2024/eventConfig.js